import { CheckCircleTwoTone, ClockCircleTwoTone, DownloadOutlined, MailOutlined, WarningTwoTone } from '@ant-design/icons';
import { Button, Image, List, Space, Tag } from 'antd';

import { isArray, isEmpty, isString } from 'lodash';
import moment from 'moment';

import { MessageStatus, SmsDirection, MessageStatusEnum } from '../../../../shared/constants/enums';
import { SMSe, SMSMediaResource } from '../../models';

import './styles.less';

export type MessageListItemProps = {
  item: SMSe;
};

const MessageListItem = ({ item }: MessageListItemProps) => {
  const getMessageAndImageFromItem = (subject: string, mediaResourceList: SMSMediaResource[], id: string) => {
    const result = [];

    if (isString(subject)) {
      result.push(<p className="message-text" key={id} dangerouslySetInnerHTML={{ __html: subject.replaceAll('\n', '<br/>') }} />);
    }

    if (isArray(mediaResourceList) && !isEmpty(mediaResourceList)) {
      mediaResourceList.forEach((element, index) => {
        if (isString(element.url) && !isEmpty(element.url)) {
          if (isString(element.fileData?.mime) && element.fileData?.mime.startsWith('image/')) {
            result.push(getImageElement(element.id, element.url));
          } else {
            result.push(getFileElement(index, element));
          }
        }
      });
    }

    return result;
  };

  const getImageElement = (index: string, imageSrc: string) => {
    return (
      <Image
        key={index}
        src={imageSrc}
        alt="message image"
        rootClassName="message-image-elm"
        preview={{
          src: imageSrc,
        }}
      />
    );
  };

  const getFileElement = (index: number, file: SMSMediaResource) => {
    return (
      <div key={file.id}>
        <Button
          type="primary"
          shape="round"
          icon={<DownloadOutlined />}
          size="small"
          onClick={() => onDownloadFile(file.url ?? '')}
          style={{ width: '100%', marginBottom: '4px' }}
        >
          Download file #{index + 1}
        </Button>
      </div>
    );
  };

  const onDownloadFile = (fileUrl: string) => {
    var link = document.createElement('a');
    document.body.appendChild(link);
    link.href = fileUrl;
    link.click();
    link.remove();
  };

  const getMessageStatusElement = (messageStatus: MessageStatus, isRead: boolean) => {
    let messageStatusElement;

    if (isRead === false) {
      messageStatusElement = <MailOutlined title="Unread" style={{ color: '#a72029' }} />;
      return messageStatusElement;
    }

    switch (messageStatus) {
      case MessageStatusEnum.queued.value:
        messageStatusElement = <ClockCircleTwoTone spin title={MessageStatusEnum.queued.text} />;
        break;

      case MessageStatusEnum.accepted.value:
        messageStatusElement = <ClockCircleTwoTone spin title={MessageStatusEnum.accepted.text} />;
        break;

      case MessageStatusEnum.failed.value:
        messageStatusElement = <WarningTwoTone title={MessageStatusEnum.failed.text} />;
        break;

      case MessageStatusEnum.undelivered.value:
        messageStatusElement = <WarningTwoTone title={MessageStatusEnum.undelivered.text} />;
        break;

      default:
        const text = Object.values(MessageStatusEnum).find((enumItem) => enumItem.value === messageStatus)?.text;

        messageStatusElement = <CheckCircleTwoTone title={text} />;
        break;
    }

    return messageStatusElement;
  };

  return (
    <List.Item className="chat-list-item" key={item.id}>
      <Tag
        id={item.id}
        className={
          item.direction === SmsDirection.Inbound
            ? 'chat-list-item-div-left'
            : item.direction === SmsDirection.Outbound
            ? 'chat-list-item-div-right'
            : undefined
        }
        color={item.direction === SmsDirection.Inbound ? 'default' : '#108ee9'}
      >
        <div className="message-cover">{getMessageAndImageFromItem(item.subject, item.mediaResourceList, item.id)}</div>

        <div className="chat-list-item-div-date">
          <Space>
            {item.direction === SmsDirection.Outbound ? item.fromNumber : null}
            <div>{moment(item.createDate).format('dddd, MMMM Do YYYY, h:mm:ss A')}</div>
            {getMessageStatusElement(item.messageStatus, item.isRead)}
          </Space>
        </div>
      </Tag>
    </List.Item>
  );
};

export default MessageListItem;
